module.exports = __webpack_public_path__ + "img/city3.224566f1.png";